/**
 * 404 Not Found Page
 */

import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Search } from 'lucide-react';
import MindoraCharacter from '../components/character/MindoraCharacter';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-kid-bg p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center max-w-lg"
      >
        <motion.img
          src="/404.png"
          alt="Page not found"
          className="w-64 h-64 mx-auto mb-4 object-contain"
          animate={{ y: [0, -10, 0] }}
          transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
        />

        <MindoraCharacter mood="thinking" size="md" className="mb-4" />

        <h1 className="text-kid-2xl font-display text-kid-text mb-2">Oops! Page Not Found</h1>
        <p className="text-kid-text-soft text-kid-base mb-8">
          Looks like this page went on an adventure and got lost.
          Let's get you back to learning!
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="btn-squishy btn-kid-ocean inline-flex items-center justify-center gap-2"
          >
            <Home className="w-5 h-5" strokeWidth={2.25} />
            Go Home
          </Link>
          <Link
            to="/learn"
            className="btn-squishy inline-flex items-center justify-center gap-2 px-6 py-3 bg-kid-violet text-white font-bold rounded-kid hover:bg-kid-violet/90 shadow-kid hover:shadow-kid-md transition-all"
          >
            <Search className="w-5 h-5" strokeWidth={2.25} />
            Start Learning
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
